import { render, staticRenderFns } from "./MyProjectsContracts.vue?vue&type=template&id=0cfcd711&scoped=true"
import script from "./MyProjectsContracts.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsContracts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsContracts.vue?vue&type=style&index=0&id=0cfcd711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcd711",
  null
  
)

export default component.exports